import { APP_NAME } from "lib/global";
import { combineReducers, createStore } from "redux";
import reducers from "./reducers";

const store = createStore(combineReducers(reducers));

store.subscribe(() => {
  const storeData = store.getState();
  window.localStorage.setItem(
    APP_NAME,
    JSON.stringify({ auth: storeData?.auth, app: storeData?.app })
  );
});

store.dispatch({ type: "CHECK_AUTH" });

export default store;
